module.exports = __webpack_public_path__ + "img/AccessDenied.2d21d5ef.png";